export function coerceText(value) {
  if (value == null) {
    return "";
  }
  return String(value).trim();
}

export function chunkItems(items, size = 3) {
  const list = Array.isArray(items) ? items : [];
  const chunks = [];
  for (let index = 0; index < list.length; index += size) {
    chunks.push(list.slice(index, index + size));
  }
  return chunks;
}

export function splitByLength(text, maxChars) {
  const value = coerceText(text);
  if (!value) {
    return [];
  }
  if (value.length <= maxChars) {
    return [value];
  }

  const sentences = value.match(/[^.!?]+[.!?]+|[^.!?]+$/g) ?? [value];
  const chunks = [];
  let current = "";

  for (const sentence of sentences) {
    const next = current ? `${current} ${sentence.trim()}` : sentence.trim();
    if (next.length <= maxChars) {
      current = next;
      continue;
    }
    if (current) {
      chunks.push(current);
    }
    if (sentence.trim().length <= maxChars) {
      current = sentence.trim();
    } else {
      chunks.push(...splitHard(sentence.trim(), maxChars));
      current = "";
    }
  }

  if (current) {
    chunks.push(current);
  }
  return chunks;
}

function splitHard(text, maxChars) {
  const chunks = [];
  let remaining = text;
  while (remaining.length > maxChars) {
    let splitAt = remaining.lastIndexOf(" ", maxChars);
    if (splitAt < maxChars * 0.6) {
      splitAt = maxChars;
    }
    chunks.push(remaining.slice(0, splitAt).trim());
    remaining = remaining.slice(splitAt).trim();
  }
  if (remaining) {
    chunks.push(remaining);
  }
  return chunks;
}

export const TEACHER_MANUAL_BUDGET = {
  overviewBody: 420,
  sidebarBody: 180,
  stepBody: 220,
  compareBody: 240,
  mediaBody: 320,
  takeaway: 220,
  title: 80,
};
